import React, { useEffect, useState, useTransition } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate } from 'react-router-dom';
import fetchUserallowedRoutes2 from '../../hooks/fetchUserallowedRoutes2';
import { getStorageItem } from '../../utils/localStorage';
import { useTranslation } from 'react-i18next';

const NewSideBar = () => {
  const { t } = useTranslation(['common']);
  const [checkRoute,setCheckRoute]=useState('');0
  const [isAdmin,setisAdmin] = useState(false);
  const [currentLocation,setCurrentLocation]=useState('');
  const [trigger,setTrigger]=useState(false);
  const [fetchedRoutes,setFetchedRoutes]=useState([]);
  const navigate = useNavigate();
  
  let user;
  getStorageItem(`user`, (result) => {
    user = JSON.parse(result);
  });
useEffect(()=>{
setisAdmin(true)

},[user]) 
   

  useEffect(()=>{
    setCurrentLocation(window.location.pathname);
  },[window.location.pathname])

  function removeDuplicates(originalArray) {
    let uniqueArray = [];
    let uniqueObject = {};
  
    for (let i = 0; i < originalArray.length; i++) {
      const obj = originalArray[i];
      const key = JSON.stringify(obj);
  
      if (!uniqueObject[key]) {
        uniqueArray.push(obj);
        uniqueObject[key] = true;
      }
    }
  
    return uniqueArray;
  }
  function mergeObjectsByKey(arr, key) {
    const groupedObjects = {};
  
    arr.forEach(obj => {
      const keyValue = obj[key];
      if (!groupedObjects[keyValue]) {
        groupedObjects[keyValue] = {};
      }
      for (let [k, v] of Object.entries(obj)) {
        if (k !== key) {
          groupedObjects[keyValue][k] = (groupedObjects[keyValue][k] || []).concat(v);
        } else {
          groupedObjects[keyValue][k] = v;
        }
      }
    });
  
    return Object.values(groupedObjects);
  }
  let serverRoutes = [];
  const routes2 = fetchUserallowedRoutes2(user.roleId).response;
  const unqArr=routes2?removeDuplicates(routes2):[];
  const mergedArr = routes2?mergeObjectsByKey(routes2, 'module'):[];
let masha=[];
let mirha=[];
routes2?routes2.map((item, index) => {
  if(item.is_root){
    masha.push(item);
  }
  else if(item.is_render&&!item.is_root){
    mirha.push(item);
  }
})
:" ";
  function extractValue(arr, module) {
    let extractedValue = arr.map((item) => {
      return item[module];
    });

    return extractedValue;
  } 
  
  let modules = [];
  if (mirha.length>0)
    mirha.forEach((ele) => {
      modules.push(ele.module);
    });
    let newArr=[]
    if (routes2)
    routes2.forEach((ele) => {
    newArr.push({module:ele.module,render:ele.is_render,action:ele.action,root:ele.is_root});
    });
    let newArray=[]

if(routes2){
  for(let i=0;i<routes2.length;i++){
  modules.forEach((ele) => {
if(ele===routes2[i].module&&routes2.is_render){
  newArray.push(routes2[i])
}
})
}
}



let matchedArray = [];


  modules = [...new Set(modules)];

  const onRouteHandler=(element)=>{
    window.alert("Hello "+element);

  }

  const masha1=JSON.parse(localStorage.getItem('masha'));
  const module2=JSON.parse(localStorage.getItem('module2'));
  const logOutHandler = () => {
    console.log("Log Out");
    let keysToRemove = ["user", "admAdId","getUserId","eventId","bannerId","productCatId","orgAdId","causeId","causeCategoryId","kioskId",
    "ethnicId","userId","donorIdforRecurring","donorId","merchantId"];
      for (let key of keysToRemove) {
        localStorage.removeItem(key);
      }
    isAdmin?navigate('/adminlogin'):navigate('/');
    window.location.reload();
  };
  const myFunc=()=>{
    
    setTrigger(true)
    document.getElementById('menu').style.cssText = 'background-color: #054155; color: white';
  }
 const  revertChanges=()=>{
  setTrigger(false)
  document.getElementById('menu').style.cssText = 'background-color: "white"; color: black';
  }
  return (
    <div style={{height:"130vh"}} id='sidebar' role='navigation'>
      <Sidebar >
      
        <Menu>
          {masha.map((ele)=>{
            
            return(
              <>
              <hr/>
             <MenuItem style={{marign:"0px",padding:"0px",backgroundColor:`${((('/'+ele.module+ele.action)===currentLocation)&&!trigger)?"#054155":" "}`,color:`${((('/'+ele.module+ele.action)===currentLocation)&&!trigger)?"white":" "}`}} onClick={revertChanges} key={ele.role_id}>
                  <Link to={`/${ele.module}${ele.action}`} style={{ textTransform: "capitalize" }}>{(ele.module === "transaction" ? "donation" : ele.module === ("event" || "events") ? "Courses & Events" : ele.module === "organization" ? "Dashboard" : ele.module === "organizations" ? "Organization" : ele.module === "orguser" ? "Users" : ele.module === "profile" ? "Organization" : ele.module === "orgads" ? "Organization Ads" : ele.module === "adminads" ? "Admin Ads" : ele.module === "orgreport" ? "Recurring" : ele.module === "paymentlink" ? "payment link" :ele.module)}</Link>
           </MenuItem>
           </>
            )
          })
          }
          {modules.map((element) => { 
      
            // if(element.root)return  <>  <hr className='fade-effect1'/><MenuItem> 
            //  <Link to={`/${element.module}${element.action}`} style={{textTransform:"capitalize"}}>{(element.module)}</Link>
            //  </MenuItem></>
            //  else 
             return (
              <>
             <hr/>
              {/* <hr className='fade-effect1'/> */}
               {
               element!='orguser'&&element!="userperm"?
               <SubMenu id="menu" style={{textTransform:"capitalize"}} onClick={myFunc}  label={((element==="transaction"?"donation":element==="events"?"Courses & Events":element==="orgreport"?"reports":element==="view"?"cause":element==="orguser"?"Users":element==="orgrecurring"?"Recurring":element ))}>
                  {routes2.map((ele) => {
                    if ((ele.module === element)&&ele.is_render) {
                      return (
                        <>
                          <hr/>
                          <MenuItem key={ele.role_id} onClick={revertChanges} style={{backgroundColor:`${((('/'+ele.module+ele.action)===currentLocation)&&!trigger)?"#054155":" "}`,color:`${((('/'+ele.module+ele.action)===currentLocation)&&!trigger)?"white":" "}`}}>
                            <Link to={`/${ele.module}${ele.action}`} onClick={revertChanges} style={{textTransform:"capitalize",backgroundColor:`${((('/'+ele.module+ele.action)===currentLocation)&&!trigger)?"#054155":" "}`,color:`${((('/'+ele.module+ele.action)===currentLocation)&&!trigger)?"white":" "}`}}>{(ele.action==="/view"?"/cause":ele.action==="/listall"?"/list":ele.action==="/donorinfo"?"/donor info":ele.action).slice(1)}</Link>
                          </MenuItem>
                          </>
                      );
                    }
                  })}
                </SubMenu>
          :" "}
              </>
            );
          })}
          <div class="row">
            <div class="col-lg-11 text-center">
            <button class=" btn button mt-5 text-white" onClick={logOutHandler}>Sign out</button>
            </div>
          </div>
          {/* <SubMenu class="mt-5" Label={"User"}>
            <MenuItem>
            Sign Out
            </MenuItem>
          </SubMenu> */}
        </Menu>
      </Sidebar>
    </div>
  );
};

export default NewSideBar;
